import { render, staticRenderFns } from "./BbeeCampanasComercialesCP.vue?vue&type=template&id=3ffc390b"
import script from "./BbeeCampanasComercialesCP.vue?vue&type=script&lang=js"
export * from "./BbeeCampanasComercialesCP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports